// src/routes/unauthorized.tsx
import { createFileRoute, Link } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';

import { PlatformFooter } from '@/components/common/PlatformFooter';
import { MyndwellMark } from '@/components/ui/brand-mark';
import { adminCopy } from '@/lib/copy';

export const Route = createFileRoute('/unauthorized')({
  component: UnauthorizedPage,
});

function UnauthorizedPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col px-6 py-12">
      <div className="flex flex-1 items-center justify-center">
        <div className="bg-surface flex max-w-md flex-col items-center gap-4 rounded-xl border border-(--color-border) p-8 text-center shadow-xs">
          <MyndwellMark size="sm" tone="ink" />

          <div className="bg-error-500/10 text-error-500 flex h-12 w-12 items-center justify-center rounded-md">
            <ShieldAlert className="h-6 w-6" strokeWidth={1.5} aria-hidden="true" />
          </div>

          <div className="space-y-1">
            <h1 className="text-body-md font-medium text-neutral-900">Not authorized</h1>
            <p className="text-body-md text-neutral-500">{adminCopy.error.forbidden}</p>
          </div>

          <Link
            to="/admin/workspace"
            className="text-body-md text-primary-500 hover:text-primary-400 mt-2 font-medium"
          >
            Go home
          </Link>
        </div>
      </div>
      <PlatformFooter className="mx-auto w-full max-w-md" />
    </div>
  );
}
